import { IAuthenticationBridgeClient } from './IAuthenticationBridgeClient';
import SignalsService from '../services/core/SignalsService';

export default class NativeRuntimeAuthenticationBridgeClient implements IAuthenticationBridgeClient {
    private nativeBridge: any;
    private signalsService: SignalsService;
    
    authenticatedUserData: any = null;
    
    constructor(signalsService: SignalsService) {
        this.signalsService = signalsService;
        this.nativeBridge = (window as any).jsBridgeAuthentication;
        
        // Initialize authenticated user data from the native bridge if available
        if (this.nativeBridge.authenticatedUserData) {
            this.authenticatedUserData = this.nativeBridge.authenticatedUserData;
        }
    }

    public tryUnlock(concatenatedKey: string): void {
        console.log("NativeRuntimeAuthenticationBridgeClient tryUnlock", concatenatedKey);
        if (!this.nativeBridge) {
            console.error("No native bridge available");
            this.signalsService.emit("tryUnlockFailed");
            return;
        }
        this.nativeBridge.tryUnlock(concatenatedKey);
    }

    public tryInvigilatorAuthentication(concatenatedKey: string): void {
        console.log("NativeRuntimeAuthenticationBridgeClient tryInvigilatorAuthentication", concatenatedKey);
        if (!this.nativeBridge) {
            console.error("No native bridge available");
            this.signalsService.emit("tryInvigilatorAuthenticationFailed");
            return;
        }
        
        try {
            const result = this.nativeBridge.tryInvigilatorAuthentication(concatenatedKey);
        } catch (error) {
            console.error("Error during invigilator authentication:", error);
            this.signalsService.emit("tryInvigilatorAuthenticationFailed");
        }
    }

    public isUnlocked(): boolean {
        if (!this.nativeBridge) {
            return false;
        }
        return this.nativeBridge.isUnlocked();
    }

    public getUserUUID(): string | null {
        if (!this.nativeBridge || !this.authenticatedUserData) {
            return null;
        }
        return this.nativeBridge.getUserUUID();
    }

    public restoreAuthenticatedUser(): object|null {
        if (!this.nativeBridge || !this.nativeBridge.restoreAuthenticatedUser) {
            return null;
        }
        const success = this.nativeBridge.restoreAuthenticatedUser();
        if (success && this.nativeBridge.authenticatedUserData) {
            this.authenticatedUserData = this.nativeBridge.authenticatedUserData;
        }
        return this.authenticatedUserData;
    }

    public logout(): void {
        this.authenticatedUserData = null;
        if (this.nativeBridge && this.nativeBridge.logout) {
            this.nativeBridge.logout();
        }
        this.signalsService.emit("logoutSuccess");
    }
} 